<template>
  <div>

    <SynologyForm />
<!--    <CallMe/>-->
<!--    <MobileCallme/>-->
  </div>
</template>

<script>
import SynologyForm from '@/components/synology/index-new.vue'
export default {
  components: {
    SynologyForm,
  },
}
</script>

<style>
</style>